export default __webpack_public_path__ + "static/media/goopter-use-case-movie-theatres.4a0d3cfd.jpg";